import React from 'react';
import { Input as ANTDInput } from 'antd';
import './style.css';
const Input = ({ ...props }) => {
  return <div className='inputComp'>{props?.type == 'password' ? <ANTDInput.Password {...props} data-testid='password-input' /> : <ANTDInput {...props} />}</div>;
};
export default Input;
